import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { PlanningSessionContext, useOptionState } from './planningSession';
export function PlanningSessionProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  return <SessionState key={user?.id ?? 'anonymous'}>{children}</SessionState>;
}
function SessionState({ children }: { children: ReactNode }) {
  const options = useOptionState();
  const [cycle, remember] = useState<string | null>(null);
  const [blocked, setBlocked] = useState(false);
  const { load } = options;
  useEffect(() => {
    let day = new Date().toDateString();
    const check = () => {
      const next = new Date().toDateString();
      if (next !== day) {
        day = next;
        if (cycle) void load(true);
      }
    };
    const timer = window.setInterval(check, 60000);
    window.addEventListener('focus', check);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', check);
    };
  }, [load, cycle]);
  return (
    <PlanningSessionContext.Provider value={{ ...options, cycle, remember, blocked, setBlocked }}>
      {children}
    </PlanningSessionContext.Provider>
  );
}
